<template>
  <div>
    <label class="mall-checkbox" v-for="(item, index) in lists" :key="index">
      <input type="checkbox" :name="`note-${item.id}`" :value="item.id" :disabled="inputValue.length > (maxnum - 1) && inputValue.indexOf(item.id) === -1" v-model="inputValue" @change="changeHandler" v-bind="$attrs">
      <span class="label-text">{{ item.name }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'MallCheckbox',

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    checked: {
      type: [String, Number, Boolean, Array, Object],
      default: ''
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    name: {
      type: String,
      default: undefined
    },
    maxnum: {
      type: Number,
      default: undefined
    },
    lists: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      inputValue: []
    }
  },
  methods: {
    changeHandler() {
      this.$emit('change', this.inputValue.toString());
    }
  }
}
</script>

<style lang="scss">
.mall-checkbox {
  display: inline-block;

  /**remove default style**/
  [type="checkbox"] {
    position: absolute;
    width: 0;
    height: 0;
    visibility: hidden;
  }

  [type="checkbox"] + .label-text {
    display: block;
    padding: 8px 11px;
    color: #121212;
    font-size: 14px;
    text-align: center;
    vertical-align: middle;
    background-color: #f8f8f8;
    border-radius: 20px;
    cursor: pointer;
    user-select: none;
  }

  /* Unchecked styles */
  [type="checkbox"]:not(:checked) + .label-text {
    color: #121212;
    background-color: #f8f8f8;
  }

  /* Checked styles */
  [type="checkbox"]:checked + .label-text {
    color: #ff5046;
    background: rgba(255, 80, 70, 0.10);
  }
}
</style>
